import AuthActionTypes from "./auth.types";

// Registration Data
export const setAuthData = (data) => ({
  type: AuthActionTypes.SET_AUTH_DATA,
  payload: data,
});

// Loading
export const loadingStart = () => ({
  type: AuthActionTypes.LOADING_START,
 
});

export const loadingStop = () => ({
  type: AuthActionTypes.LOADING_STOP,

});

// Sign In
export const signInRequest = (payload) => ({
  type: AuthActionTypes.SIGN_IN_REQUEST,
  payload: payload,
});

export const signInSuccess = (user) => ({
  type: AuthActionTypes.SIGN_IN_SUCCESS,
  payload: user,
});

export const signInFailure = (error) => ({
  type: AuthActionTypes.SIGN_IN_FAILURE,
  payload: error,
});

// Sign Out
export const signOutRequest = (payload) => ({
  type: AuthActionTypes.SIGN_OUT_REQUEST,
  payload: payload,
});

export const signOutSuccess = () => {
  return {
    type: AuthActionTypes.SIGN_OUT_SUCCESS,
  };
};

export const signOutFailure = (error) => ({
  type: AuthActionTypes.SIGN_OUT_FAILURE,
  payload: error,
});

// Register
export const registerRequest = (payload) => ({
  type: AuthActionTypes.REGISTER_REQUEST,
  payload: payload,
});

export const registerSuccess = (payload) => ({
  type: AuthActionTypes.REGISTER_SUCCESS,
  payload: payload,
});

export const registerFailure = (error) => ({
  type: AuthActionTypes.REGISTER_FAILURE,
  payload: error,
});

// Register Initiate (Email Verification)
export const registerInitiateRequest = (payload) => ({
  type: AuthActionTypes.REGISTER_INITIATE_REQUEST,
  payload: payload,
});

export const registerInitiateSuccess = (payload) => ({
  type: AuthActionTypes.REGISTER_INITIATE_SUCCESS,
  payload: payload,
});

export const registerInitiateFailure = (error) => ({
  type: AuthActionTypes.REGISTER_INITIATE_FAILURE,
  payload: error,
});

// Register Complete
export const registerCompleteRequest = (payload) => ({
  type: AuthActionTypes.REGISTER_COMPLETE_REQUEST,
  payload: payload,
});

export const registerCompleteSuccess = (payload) => ({
  type: AuthActionTypes.REGISTER_COMPLETE_SUCCESS,
  payload: payload,
});

export const registerCompleteFailure = (error) => ({
  type: AuthActionTypes.REGISTER_COMPLETE_FAILURE,
  payload: error,
});

// Reset Auth State
export const resetAuthState = () => ({
  type: AuthActionTypes.RESET_AUTH_STATE,
});


